import React from "react";
import styles from "./nav-item.module.css";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { LOCALES } from "../../../constants";
import { getUIText } from "../../../translation";

export default function NavItem({ to }) {
    const lang = useSelector((state) => state.lang.value);

    const text = getUIText(lang, `header.title.${to === "simulator/savior" ? "simulatorSavior" : to === "music" ? "bgm" : to}`);

    return (
        <Link className={styles["nav-item"]} to={`/${to}`}>
            <div className={styles["icon"]}>
                {to !== "music" && to !== "wallpaper" && to !== "simulator/savior" && to !== "monster" && to !== "potential" && (
                    <img src={`${process.env.PUBLIC_URL}/images/index/${to}.png`} />
                )}
                {to === "music" && <i className="fi fi-rs-music-alt" />}
                {to === "wallpaper" && <i className="fi fi-rr-desktop-wallpaper" />}
                {to === "simulator/savior" && <i className="fi fi-rr-dashboard-monitor" />}
                {to === "monster" && <i className="fi fi-rr-skull" />}
                {to === "potential" && <i className="fi fi-rr-sparkles" />}
            </div>
            <span>{text}</span>
        </Link>
    );
}
